var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from '@mui/material';
import { getUserColor } from '../../utils/color';
const getInitials = (displayName) => {
    const nameSplits = displayName.split(' ');
    let initials = '';
    nameSplits
        .filter((item) => item.length > 0)
        .slice(0, 2)
        .forEach((str) => {
        initials += str.substring(0, 1).toUpperCase();
    });
    return initials;
};
const UserAvatar = (_a) => {
    var { user, variant = 'circular', style } = _a, avatarProps = __rest(_a, ["user", "variant", "style"]);
    const name = user.displayName || user.Name || '';
    const avatarUrl = user.avatarUrl || user.AvatarUrl || undefined;
    const initials = user.initials || getInitials(name);
    const backgroundColor = name ? getUserColor(user) : null;
    const textColor = backgroundColor ? '#ffffff' : undefined;
    return (_jsx(Avatar, Object.assign({ style: Object.assign({ backgroundColor, color: textColor }, style), title: name, alt: name, src: avatarUrl, variant: variant }, avatarProps, { children: initials })));
};
export default UserAvatar;
